export default __webpack_public_path__ + "static/media/1.f023afc4.png";